module.exports = __webpack_public_path__ + "static/media/Hollow.f80ef4f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/EOFYtrends/Hollow.png
// module id = 476
// module chunks = 0